import { Component, EventEmitter, Inject, inject, Input, Optional, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IHelpService, IHelpExtensionHandler } from '../../core/interfaces';
import { HELP_SERVICE, HELP_EXTENSION_HANDLER } from '../../core/tokens';
import { HelpModalComponent } from './help-modal.component';
import { ControlsIconsModule } from '../icons.module';

@Component({
	standalone: true,
	selector: 'wd-help',
	template: `
		<span *ngIf="helpService.has(name)" class="help-icon" (click)="openHelp(); $event.stopPropagation()">
			<bi name="info-circle"></bi>
		</span>
	`,
	styles: [`
		.help-icon {
			color: #6c757d;
			cursor: help;
			margin-left: 8px;
		}
		:host {
			display: inline-flex;
			align-items: center;
			vertical-align: middle;
		}
		.help-icon:hover {
			color: #0d6efd;
		}
	`],
	imports: [CommonModule, ControlsIconsModule]
})
export class HelpComponent {
	@Input() name!: string;
	@Input() context: Record<string, any> = {};
	@Output() valueSelected = new EventEmitter<any>();

	private modalService = inject(NgbModal);

	constructor(
		@Inject(HELP_SERVICE) public helpService: IHelpService,
		@Inject(HELP_EXTENSION_HANDLER) @Optional() private extensionHandler: IHelpExtensionHandler
	) {}

	openHelp() {
		// Prüfe ob ein app-spezifischer Handler zuständig ist
		if (this.extensionHandler?.canHandle(this.name)) {
			const result = this.extensionHandler.openHelp(this.name, this.context, this.modalService);
			if (result) {
				result.then(
					(value: any) => this.valueSelected.emit(value),
					() => {} // dismissed
				);
			}
			return;
		}

		// Standard: Text/Liste anzeigen
		const modalRef = this.modalService.open(HelpModalComponent, { centered: true, windowClass: 'help-modal-auto-width' });
		modalRef.componentInstance.name = this.name;
		modalRef.componentInstance.text = this.helpService.text(this.name);
		modalRef.componentInstance.list = this.helpService.list(this.name);
	}
}
